import request from '@/utils/request'
import backend from '@/config/globalConfig'
export async function announcementRequest(path = '', options = {}) {
  const response = await request({ url: backend.url + '/announcements' + path, method: 'get', ...options,
    headers: { isSaToken: true, ...(options.headers || {}) } })
  if (![0, 200].includes(response.data.code) || response.data.data === false && options.method === 'post') throw new Error(response.data.msg || '操作失败')
  return response.data.data
}
